import React from 'react'
import { Container, Button, Row, Col } from 'reactstrap'
import './index.scss'
import Pricing from '../../components/subcription/pricing'

import { Link, useNavigate } from 'react-router-dom'
import logo from '../../images/logo.svg'
const PricingIndex = () => {
  const navigate = useNavigate()

  return (
    <div className="landing-page pricing-page" style={{ minHeight: '100vh', background: '#232228', color: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <Container className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
        <Row className="header">
          <Col>
            <Link to="/">
              <img src={logo} alt='logo' className='logo' />
            </Link>
          </Col>
          <Col className="login-box">
            <Button onClick={() => navigate('/login')}>Login</Button>
          </Col>
        </Row>

        <Pricing
          successUrl = '/onboarding'
          cancelUrl = '/pricing'
        />
      </Container>
    </div>
  )
}

export default PricingIndex
